<template>
  <div @touchmove="touch" v-touch:swipe="swipeHandler" @wheel="wheel" class="albumPhoto">
    <transition name="fade">
      <div class="voileNoir" @click="close" />
    </transition>
    <div class="boutonsHd">
      <img
        v-if="$parent.ownProfile"
        @click="deletePicture"
        :src="'/assets/icons_' + $store.state.iconTheme + '/trash.png'"
        class="trash"
      />
      <a @click="close" class="close">
        <img :src="'/assets/icons_' + $store.state.iconTheme + '/cross2.png'" />
      </a>
    </div>
    <div class="conteneur">
      <div class="leftSide">
        <a @click="prec" :class="{ active: selectedIndex > 0 }" class="fleche">
          &lt;
        </a>
      </div>
      <div class="cadrePhotoAlbum">
        <div class="photos">
          <div class="container">
            <transition :name="albumTransition">
              <Photo
                v-if="profile.pictures.length > 0"
                :profile="profile"
                :pic="profile.pictures[selectedIndex]"
                :key="profile.pictures[selectedIndex].id"
                class="photo"
              />
            </transition>
          </div>
        </div>
        <div class="progress">
          <div
            :class="{ picSquare: true, selected: index === selectedIndex }"
            v-for="(pic, index) in profile.pictures"
            :key="pic.id"
          />
        </div>

        <a class="boutonChoisir" v-if="$parent.ownProfile" :class="{ inactive: !canBeMain }" @click="setMain">
          Choisir comme photo de profil
        </a>
      </div>
      <div class="rightSide">
        <a @click="suiv" :class="{ active: selectedIndex < profile.pictures.length - 1 }" class="fleche">
          &gt;
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Photo from "@/components/profile/Photo";
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";

export default {
  name: "AlbumPhoto",
  components: { Photo },
  props: ["profile"],
  data() {
    return {
      selectedIndex: 0,
      albumTransition: "none"
    };
  },

  computed: {
    canBeMain: function() {
      return (
        this.$parent.ownProfile &&
        this.profile.pictures.length >= 1 &&
        this.profile.pictures[this.selectedIndex].type === 0
      );
    }
  },

  created: function() {},

  methods: {
    touch: function(event) {
      event.preventDefault();
      event.stopPropagation();
    },

    init: function() {
      this.albumTransition = "none";
    },

    close: function() {
      this.$router.push({ name: "Profil", query: this.$route.query });
    },

    prec: function() {
      if (this.selectedIndex !== 0) {
        this.selectedIndex--;
        this.albumTransition = "albuml";
      }
    },

    suiv: function() {
      if (this.selectedIndex < this.profile.pictures.length - 1) {
        this.albumTransition = "albumr";
        this.selectedIndex++;
      }
    },

    wheel: function(e) {
      e.preventDefault();
      e.stopPropagation();
    },

    selectById: function(id) {
      if (id !== 0) this.selectedIndex = this.profile.pictures.findIndex(elt => elt.id === id);
      else this.selectedIndex = 0;
    },

    setMain: async function() {
      if (this.canBeMain) {
        await idyuJsonRpc("setMainPicture", this.profile.pictures[this.selectedIndex].id);
        this.profile.mainPicture = this.profile.pictures[this.selectedIndex];
        await alert("Photo de profil définie !");
      }
    },

    deletePicture: async function() {
      if (await confirm("Etes-vous sur de vouloir supprimer cette photo ?")) {
        const idMain = await idyuJsonRpc("deletePicture", this.profile.pictures[this.selectedIndex].id);
        this.profile.pictures.splice(this.selectedIndex, 1);
        if (this.selectedIndex !== 0) this.selectedIndex--;
        if (idMain === 0) {
          // this should always fetch a "picto" picture from the server
          const newMain = await idyuJsonRpc("getMainPicture");
          if (newMain.id === 0) this.profile.mainPicture = newMain;
        } else {
          const found = this.profile.pictures.find(elt => elt.id === idMain);
          if (found)
            // should never be null
            this.profile.mainPicture = found;
        }
        await alert("Photo supprimée !");
      }
    },

    swipeHandler: function(direction) {
      if (direction === "left") this.suiv();
      if (direction === "right") this.prec();
    },

    prevent: function(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/vars.scss";

.inactive {
  color: #999 !important;
}

.albumPhoto {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 500;
  display: grid;
  grid-template-columns: auto;
  align-items: center;
  justify-content: center;
}

.voileNoir {
  background-color: black;
  opacity: 0.8;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
}

.conteneur {
  display: grid;
  grid-template-columns: auto auto auto;
  a.fleche {
    color: #999;
    font-weight: bold;
    font-size: 40px;
    cursor: pointer;
    &.active {
      color: white !important;
      &:hover {
        color: $theme_color !important;
      }
    }
  }
  align-items: center;
  grid-gap: 10px;
  position: relative;
}

.cadrePhotoAlbum {
  display: grid;
  position: relative;
  background-color: white;
  padding: 5px;

  img {
    max-height: calc(100vh - 150px);
    max-width: calc(100vw - 100px);
  }

  .photos {
    min-width: 768px;
    position: relative;
    overflow: hidden;
    background-color: black;
    display: grid;
    position: relative;
    overflow: hidden;
    align-items: center;
    justify-items: center;
    .container {
      grid-column: 1;
      grid-row: 1;
      display: grid;
      align-items: center;
      justify-items: center;
      overflow: hidden;
      .photo {
        grid-column: 1;
        grid-row: 1;
      }
    }
  }
}

.boutonsHd {
  position: fixed;
  z-index: 2000;
  top: 5px;
  right: 5px;
  img {
    filter: brightness(5);
  }
}

.trash {
  width: 20px;
  height: 20px;
  background-color: black;
  padding: 3px;
  border-radius: 5px;
  margin-right: 10px;
  cursor: pointer;
}

.close {
  cursor: pointer;
}

.boutonChoisir {
  background-color: white;
  text-align: center;
  padding: 5px;
  font-weight: bold;
  cursor: pointer;
}

.progress {
  height: 5px;
  border: $light_border;
  display: grid;
  grid-auto-flow: column;

  .picSquare {
    border: $light_border;

    &.selected {
      background-color: $theme_color;
    }
  }
}

@media screen and (max-width: 880px) {
  .photos {
    min-width: 0 !important;
    width: calc(100vw - 100px);
  }
}

@media screen and (max-width: 470px) {
  .cadrePhotoAlbum {
    position: relative;
    background-color: white;
    display: grid;
    padding: 0px;
    background-color: black;
    height: 100vh;
    align-items: center;
    grid-template-rows: 1fr min-content min-content;
    img {
      max-height: calc(100vh - 50px);
      max-width: 100vw;
    }

    .photos {
      height: calc(100vh - 50px);
      width: 100%;
      position: relative;
      overflow: hidden;
      background-color: black;
      display: grid;
      position: relative;
      overflow: hidden;
      align-items: center;
      justify-items: center;

      .container {
        width: 100%;
      }
    }
    .boutonChoisir {
      z-index: 500;
      position: fixed;
      height: 19px;
      bottom: 0;
      left: 0;
      right: 0;
    }
    .progress {
      z-index: 500;
      position: fixed;
      bottom: 29px;
      left: 0;
      right: 0;
    }
  }
  .conteneur {
    grid-gap: 0;
  }

  .leftSide {
    position: fixed;
    bottom: 40px;
    left: 10px;
    z-index: 500;
  }

  .rightSide {
    position: fixed;
    bottom: 40px;
    right: 10px;
  }

  .voileNoir {
    opacity: 1;
  }
}

.albumr-enter-active {
  transition: all 0.5s;
}

.albumr-leave-active {
  transition: all 0.5s;
}
.albumr-enter {
  transform: translateX(100%);
}

.albumr-leave-to {
  transform: translateX(-100%);
}

.albuml-enter-active {
  transition: all 0.5s;
}

.albuml-leave-active {
  transition: all 0.5s;
}

.albuml-enter {
  transform: translateX(-100%);
}

.albuml-leave-to {
  transform: translateX(100%);
}
</style>
